import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6 lg:mt-12" }

import axios from 'axios';
import { reactive, ref } from 'vue';
import AppNews from './AppNews.vue';
import AppSlides from './AppSlides.vue';
import { setTitle } from '../title';
import AppLoading from './AppLoading.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const slides = [
  {
    image: '/images/bannertop1.jpeg',
    text: 'КРУПНЕЙШИЙ В РОССИИ ЦЕНТР ПО ТЕХНИЧЕСКИМ ИССЛЕДОВАНИЯМ И СКВОЗНОЙ АНАЛИТИКЕ',
  },
  {
    image: '/images/bannertop2.jpeg',
    text: 'ДЕТАЛЬНАЯ АНАЛИТИКА СВЫШЕ 100 ТИПОВ ТЕХНИКИ — ВЫБИРАЙТЕ УДОБНЫЙ ВАМ ТАРИФНЫЙ ПАКЕТ И БУДЬТЕ НА РЫНКЕ',
  },
];

const news = ref(null);
const loading = ref(true);

axios.get('/api/news').then((response) => {
  news.value = response.data.data;
  loading.value = false;
});

setTitle('Государственный центр технических исследований', true)


return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(AppLoading, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(AppSlides, { slides: slides }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppNews, { news: news.value }, null, 8, ["news"])
        ])
      ], 64))
}
}

})